import { actionCreator,
  checkHttpStatus,
  GET_MASTERDATABYNAME,
  jsonApiHeader,
  rolePermissionActionTypes,
  ROLEPERMISSIONAPI,
  showErrorMessage, showSuccessMessage, showWarningMessage,
} from '../constants/ApiConstants';

export const getRolePermissions = (roleId) => {
  // console.log(queryParams)
  let fetchUrl = `${ROLEPERMISSIONAPI}/GetRolePermissions?roleId=${roleId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(rolePermissionActionTypes.get_role_permissions.REQUEST));
    fetch(fetchUrl, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        dispatch(actionCreator(rolePermissionActionTypes.get_role_permissions.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_tags  --', error);
      });
  };
};

export const getMasterData = () => {
  let fetchUrl = `${GET_MASTERDATABYNAME}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(rolePermissionActionTypes.get_masterdata.REQUEST));
    fetch(fetchUrl, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'masterRoles' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.....', response);
        dispatch(actionCreator(rolePermissionActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error get_masterdata search --', error);
      });
  };
};

export const saveRolePermission = (formProps, roleId) => {

  let PostData = JSON.stringify(formProps);

  return (dispatch, getState) => {
    dispatch(actionCreator(rolePermissionActionTypes.post_role_permission.REQUEST));
    fetch(`${ROLEPERMISSIONAPI}/SaveRolePermissions`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: PostData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(getRolePermissions(roleId));
        if (response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(rolePermissionActionTypes.post_role_permission.SUCCESS, response));
        } else if (response.statusCode === 500) {
          showWarningMessage(response.message);
          dispatch(actionCreator(rolePermissionActionTypes.post_role_permission.SUCCESS, response));
        } else {
          dispatch(actionCreator(rolePermissionActionTypes.post_role_permission.SUCCESS, response));
          showSuccessMessage(response.message);
        }
      })
      .catch(function(error) {
        // dispatch(actionCreator(manageTagActionTypes.post_tag.FAILURE));
        console.log('error----', error);
        showErrorMessage(error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/actions/RolePermissionActions.js